// extracted by mini-css-extract-plugin
export default {"dialog":"PatientPreconfigDialog_dialog__MeJoH","content":"PatientPreconfigDialog_content__hkEs8","bottomContainer":"PatientPreconfigDialog_bottomContainer__g3I5b"};